export default __webpack_public_path__ + "media/components/ResultCard/actra-46ded6a3bbef3f1bdeca78e9b1bc991b.png";